//
//
//
//
//
//
//

import Vue from "vue";
export default {
  name: "headNav",
  props: {
    //跳转路由名称
    title: {
      type: String,
      default: "顶呱呱新零售"
    },
    //颜色
    type: {
      type: String,
      default: ""
    },
    showBack: {
      type:Boolean,
      default: true
    }
  },
  methods: {
    goback() {
       this.$router.back(-1);
    },
  }
};



// WEBPACK FOOTER //
// ./src/components/headNav.vue